// @flow

export const AUTH_TOKEN = 'loyalman_auth_token';
export const USERNAME = 'loyalman_username';
export const USER_ID = 'loyalman_user_id';
export const INF_NOTIFICATIONS = 'loyalman_inf_notifications';
export const LOGOUT_MESSAGE = 'loyalman_logout_message';
export const API_URL_COOKIE = 'loyalman_url';

const COOKIE_EXPIRATION = 300; // days
const expDate = new Date();
expDate.setDate(expDate.getDate() + COOKIE_EXPIRATION);
export const cookiesSetting = { path: '/', expires: expDate };

export const localeDefaultCookie = 'loyalman_language';
export const localeAllowSwitcherCookie = 'loyalman_allow_language_switcher';

export const GLOBAL_DEFAULT_LANGUAGE = 'sk';
